import React from "react"

const AssessmentLink = () => (
  <a href="https://1o5dmry8dy0.typeform.com/to/m1PuXyVL?utm_campaign=dssurvey" className="cmp-button cmp-button--inverse">Take the Assessment</a>
)

export default AssessmentLink
